export default "__VITE_ASSET__1eSvtH0K__"